module.exports = __webpack_public_path__ + "img/p1-p1-chuan.81ea9247.png";